/**
 * TagSelect - Selector de etiquetas reutilizable
 * 
 * Usado en filtros de gastos, tareas, etc.
 * Muestra un indicador de color junto al nombre de la etiqueta.
 */
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

export interface Tag {
    id: string;
    name: string;
    color: string;
}

interface TagSelectProps {
    /** Lista de etiquetas disponibles */
    tags: Tag[];
    /** Valor seleccionado (id de la etiqueta o empty string para "todas") */
    value: string;
    /** Callback cuando cambia la selección */
    onChange: (value: string) => void;
    /** Placeholder cuando no hay selección */
    placeholder?: string;
    /** Texto para la opción "todas" */
    allLabel?: string;
    /** Clases adicionales para el trigger */
    className?: string;
}

const TagSelect = ({
    tags,
    value,
    onChange,
    placeholder = "Todas las etiquetas",
    allLabel = "Todas las etiquetas",
    className = "w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0",
}: TagSelectProps) => {
    return (
        <Select
            value={value || "all"}
            onValueChange={(val) => onChange(val === "all" ? "" : val)}
        >
            <SelectTrigger className={className}>
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="all">{allLabel}</SelectItem>
                {tags.map((tag) => (
                    <SelectItem key={tag.id} value={tag.id}>
                        <div className="flex items-center gap-2">
                            <div
                                className="w-3 h-3 rounded-full"
                                style={{ backgroundColor: tag.color }}
                            />
                            {tag.name}
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default TagSelect;
